import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "container score mb-3" };
const _hoisted_2 = {
    key: 1,
    class: "row mt-3 justify-content-center"
};
const _hoisted_3 = {
    key: 2,
    class: "row mt-3 ml-0",
    "data-cy": "tabular-messages"
};
const _hoisted_4 = { class: "col-auto px-2" };
const _hoisted_5 = {
    key: 3,
    class: "row mt-3 ps-0",
    "data-cy": "recommendations"
};
const _hoisted_6 = { class: "col-auto px-0" };
const _hoisted_7 = {
    key: 4,
    class: "row mt-3 ps-0"
};
const _hoisted_8 = { class: "row col-12 align-items-center" };
const _hoisted_9 = { class: "me-1" };
const _hoisted_10 = { "data-cy": "sorting-algorithm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($setup.banner)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "row mt-1 justify-content-center banner",
                style: _normalizeStyle(`color: ${$setup.banner.color || 'grey'}`)
            }, _toDisplayString($setup.banner.text), 5))
            : _createCommentVNode("", true),
        ($setup.totalScore)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", {
                    class: _normalizeClass(["row col-auto justify-content-center align-items-center total-score", `background-color-${$setup.totalScore.color}`]),
                    "data-cy": "total-score",
                    style: _normalizeStyle(`background-color: ${$setup.totalScore.color || 'grey'}`)
                }, _toDisplayString($setup.totalScore.score), 7)
            ]))
            : _createCommentVNode("", true),
        ($setup.tabularMessages.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabularMessages, (message) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "row flex-nowrap mt-2 align-items-center",
                        key: message.text
                    }, [
                        _createElementVNode("div", {
                            class: "col-auto px-0 tabular-block",
                            style: _normalizeStyle(`background-color: ${message.color || 'grey'}`)
                        }, null, 4),
                        _createElementVNode("div", _hoisted_4, [
                            _createTextVNode(_toDisplayString(message.text), 1),
                            (message.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(": " + _toDisplayString(message.value), 1)
                                ], 64))
                                : _createCommentVNode("", true)
                        ])
                    ]));
                }), 128))
            ]))
            : _createCommentVNode("", true),
        ($setup.recommendations.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.recommendations, (recommendation) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "row col-12 mt-2 align-items-center",
                        key: recommendation.text
                    }, [
                        _createElementVNode("div", _hoisted_6, [
                            _createTextVNode(_toDisplayString(recommendation.text), 1),
                            (recommendation.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(": " + _toDisplayString(recommendation.value), 1)
                                ], 64))
                                : _createCommentVNode("", true)
                        ])
                    ]));
                }), 128))
            ]))
            : _createCommentVNode("", true),
        ($setup.sortingAlgorithm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("strong", _hoisted_9, _toDisplayString(_ctx.$t('JTADM_RESPONSE_SORTING_ALGORITHM')) + ":", 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString($setup.sortingAlgorithm), 1)
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
